
function Loadtext(){
        let btnLoad=document.querySelectorAll('#btn__load-more');
        let btnHide=document.querySelectorAll('#btn__hide-more');
        let loadInner=document.querySelectorAll('.ecocabin-module__text--all');

        btnLoad.forEach((elem) => {

            elem.addEventListener('click', (e) => {
                e.preventDefault();
                elem.style.display="none";

                btnHide.forEach(elem=>{
                    elem.style.display="block";

                });

                loadInner.forEach(elem=>{
                    elem.classList.remove('ecocabin-module__text--short');

                });
            });
        });

        btnHide.forEach((elem) => {

            elem.addEventListener('click', (e) => {
                e.preventDefault();

                elem.style.display="none";

            loadInner.forEach(item=>{
                item.classList.add('ecocabin-module__text--short');
                btnLoad.forEach((thing) => {
                    thing.style.display="block";
                });
            });
            });
        });

}

Loadtext();
